import { ICellRendererAngularComp } from "ag-grid-angular";
import { signal } from "@angular/core";
import { ICellRendererParams } from "ag-grid-community";
import { IndividualRelationshipGroupModel } from "../../models/individual-relationship-group-model";

export type CellRendererParams = ICellRendererParams<IndividualRelationshipGroupModel, unknown> & {
  updateNonMatchingEntity: (relationship: IndividualRelationshipGroupModel) => void
  valueToMatch: unknown;
};

export class BaseNonMatchingCell implements ICellRendererAngularComp {
  matches = signal<boolean>(true);
  params!: CellRendererParams;

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    this.params = params;
    this.matches.set(this.getIsMatches());
    return true;
  }

  onUpdateMisMatch(): void {
    this.params.updateNonMatchingEntity(this.params.data!);
  }

  getIsMatches(): boolean {
    return this.params.value == this.params.valueToMatch;
  }
}
